import {
    GetDrawDownRepaymentScheduleIwocapayResponse,
    GetFormalOffersResponse,
    GetIwocapayPaymentLaterResponse,
    LapiError
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export function useGetDrawDownRepaymentScheduleIwocapay({
    payLink,
    offer
}: {
    payLink: GetIwocapayPaymentLaterResponse['data'][number];
    offer?:
        | NonNullable<GetFormalOffersResponse['data']>['formal_offers'][number]
        | null;
}) {
    const stateKey = useStateKey();

    const { data, isLoading } = useQuery({
        queryKey: [
            'fetchGetDrawDownRepaymentScheduleIwocapay',
            offer,
            payLink,
            stateKey
        ],
        queryFn: () => {
            return fetchGetDrawDownRepaymentScheduleIwocapay({
                stateKey,
                offerId: offer!.offer_id!,
                query: { payLinkId: payLink.id }
            });
        },
        enabled: Boolean(payLink) && Boolean(offer)
    });

    return {
        drawDownRepaymentScheduleIwocapay: data?.data || null,
        loadingDrawDownRepaymentScheduleIwocapay: isLoading
    };
}

const BUYER_REGISTRATION_API_TOKEN =
    'Token iwoca-2ay95jmavm6gw12hf20iq97oc1bb5okti3c';
const lendingApiFetchJson = (url: string, options = {}, headers = {}) =>
    // eslint-disable-next-line iwoca/prefer-lapi-client
    fetch(url, {
        credentials: 'same-origin',
        ...options,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            authorization: BUYER_REGISTRATION_API_TOKEN,
            ...headers
        }
    });

/** Django hasn't generated the correct schema -> Missing query params */
async function fetchGetDrawDownRepaymentScheduleIwocapay({
    stateKey,
    offerId,
    query: { payLinkId }
}: {
    stateKey: string;
    offerId: string;
    query: { payLinkId: string };
}): Promise<GetDrawDownRepaymentScheduleIwocapayResponse> {
    const res = await lendingApiFetchJson(
        `/api/lending/edge/draw_down_repayment_schedule/${stateKey}/iwocapay/${offerId}/?pay_link_id=${payLinkId}`
    );

    if (!res.ok) {
        throw new LapiError(res.status, await res.text());
    }

    return res.json();
}
